export const theme = {
  colors: {
    primary: '#e3f2fd',      // Light blue
    secondary: '#e8f5e9',   // Light green
    white: '#ffffff',
    text: '#263238',
    accent: '#4caf50',     // Green accent
    lightGray: '#f5f5f5',
  },
  fonts: {
    primary: '"Poppins", sans-serif',
    secondary: '"Playfair Display", serif',
  },
  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
  },
};
